import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const counter = css`
  opacity: 0.5;
`

export const field = css`
  inline-size: 100%;
  padding-block: ${spacing(2)};
  // GWC навешивает минимальную высоту на обёртку textarea,
  // из-за чего текст прыгает при переносе строки
  & > div {
    min-block-size: auto !important;
  }
`
